<template>
  <div>
    <div class="field">
      <label class="label">{{ $t("api token") }}</label>
      <p class="control is-expanded has-icons-left">
        <input type="text" class="input" v-model="meta.api_token" />
        <span class="icon is-small is-left">
          <i class="fa fa-user"></i>
        </span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      meta: {
        service_url: "",
        campaign: "",
        agent: "",
        origin: "",
      },
    };
  },
  methods: {
    get_data() {
      return this.meta;
    },
    set_data(data) {
      this.meta = data;
    },
    clear() {
      this.meta = {
        service_url: "",
        campaign: "",
        agent: "",
        origin: "",
      };
    },
  },
};
</script>
